// usePaymentSection.js
import { useState, useCallback } from "react";
import { ManageApis } from "../../common/APIS/ManageApis";
import {
  FailedPopup,
  customLogger,
  getSessionStorage,
  loadScript,
  setSessionStorage,
} from "../../common/Utils/Utils";
import { useNavigate } from "react-router-dom";
import { Constant, defaultTexts } from "../../constant";
import { load } from "@cashfreepayments/cashfree-js";
import { fedBankPG } from "./fedBankPG";

const usePaymentSection = (token, redirect_url, HandleAfterPayment) => {
  const navigate = useNavigate();
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [PaymentGateWays, setPaymentGateWays] = useState([]);
  const [loader, setLoader] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [OpenPaymentStatusModal, setOpenPaymentStatusModal] = useState(false);
  const [paymentPending, setPaymentPending] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentStatusMsg, setPaymentStatusMsg] = useState("");
  const [showPriceBanner, setShowPriceBanner] = useState(false);

  const handleDisableButton = () => setButtonDisable(true);
  const handleEnableButton = () => setButtonDisable(false);

  const handleGateWay = async (
    PaymentGateWay,
    secret_key,
    paramData = { total_amount: 0 },
    unregister_user,
    complete_details
  ) => {
    if ((paramData.total_amount && PaymentGateWay) || secret_key) {
      handleDisableButton();
      let userData = {};
      let orderDetails = {};

      if (
        !["AXIS", "SIB", "FED", "AXIS_CF", "UBI", "SBI"].includes(
          PaymentGateWay
        )
      ) {
        handleEnableButton();
        return FailedPopup(
          "The Service currently not available. Please try later"
        );
      }

      let sessiondata = getSessionStorage("userdetails");
      const { email, mobile, first_name, last_name } = sessiondata || {};
      userData = { email, mobile, first_name, last_name };

      let body = {
        amount: paramData.total_amount,
        gateway: PaymentGateWay,
        source: redirect_url ? "mobile" : "web",
      };

      if (body.amount && body.gateway && token && !unregister_user) {
        ManageApis("post", global.createtransaction, body, token)
          .then((res) => {
            customLogger("order create response", res);
            const { status, data } = res.response_data;
            if (status === true) {
              const {
                pg_order_id,
                amount,
                transaction_id,
                currency,
                gateway_details,
                payment_session_id,
                environment,
              } = data;
              orderDetails = {
                pg_order_id,
                amount,
                transaction_id,
                currency,
                gateway_details,
                payment_session_id,
                environment,
                ...gateway_details,
              };
              setSessionStorage(
                "paymentDetails",
                JSON.stringify({ ...data, PaymentGateWay })
              );
              return PGSection(secret_key);
            } else {
              FailedPopup(res);
              handleEnableButton();
              return;
            }
          })
          .catch(async (err) => {
            console.log("order create error response", err);
            handleEnableButton();
          });
      } else if (unregister_user) {
        const {
          pg_order_id,
          amount,
          transaction_id,
          currency,
          gateway_details,
          payment_session_id,
          environment,
        } = complete_details;
        orderDetails = {
          pg_order_id,
          amount,
          transaction_id,
          currency,
          gateway_details,
          payment_session_id,
          environment,
          ...gateway_details,
        };
        setSessionStorage(
          "paymentDetails",
          JSON.stringify({ ...complete_details, PaymentGateWay })
        );
        return PGSection(secret_key);
      }

      async function PGSection(secret_key) {
        !redirect_url && handleClosePaymentModal();
        switch (PaymentGateWay) {
          case "AXIS":
            RazorpayPayment(secret_key);
            break;
          case "SIB":
            RazorpayPayment(secret_key);
            break;
          case "FED":
            FEDBankPayment(orderDetails.gateway_details);
            break;
          case "AXIS_CF":
            CashFreePayment();
            break;
          case "UBI":
            EaseBuzzPayment();
            break;
          case "SBI":
            SBIPayment();
            break;
          default:
            break;
        }
      }

      async function RazorpayPayment(secret_key) {
        setLoader(true);
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
          const errorMessage = "Razorpay SDK failed to load. Are you online?";
          FailedPopup(errorMessage);
          setLoader(false);
          return;
        }

        const { email, mobile, first_name, last_name } = userData;
        let options = {
          image: PaymentGateWays.gateway_logo,
          currency: orderDetails.currency,
          key: secret_key,
          amount: orderDetails.amount,
          name: "KSFE Ltd",
          order_id: orderDetails.pg_order_id,
          prefill: {
            email: email || "",
            contact: mobile || "",
            name: `${first_name} ${last_name}` || "",
          },
          handler: async (data) => {
            // navigate(-1);
            customLogger(
              `Payment success payment id : ${data.razorpay_payment_id}`
            );
            if (data.razorpay_payment_id) {
              await UpdatePaymentResponse(
                true,
                orderDetails.transaction_id,
                PaymentGateWay,
                data.razorpay_order_id,
                data.razorpay_payment_id,
                data.razorpay_signature,
                "",
                token,
                unregister_user
              );
              setPaymentStatusMsg(Constant.paymentsussessMsg);
              setPaymentSuccess(true);
              setOpenPaymentStatusModal(true);
              HandleAfterPayment();
            } else {
              await UpdatePaymentResponse(
                false,
                orderDetails.transaction_id,
                PaymentGateWay,
                orderDetails.pg_order_id,
                "",
                "",
                "",
                token,
                unregister_user
              );
              setPaymentStatusMsg(
                data.error.reason.replace("_", " ") | data.error.description
              );
              setPaymentSuccess(false);
              setOpenPaymentStatusModal(true);
              HandleAfterPayment();
            }
          },
          modal: {
            ondismiss: function () {
              // if (!unregister_user) {
              //   navigate(-1);
              // }
              UpdatePaymentResponse(
                false,
                orderDetails.transaction_id,
                PaymentGateWay,
                orderDetails.pg_order_id,
                "",
                "",
                "",
                token,
                unregister_user
              );
              setPaymentStatusMsg(defaultTexts?.paymentFailedMsg);
              setPaymentSuccess(false);
              setOpenPaymentStatusModal(true);
              HandleAfterPayment();
              // const errorMessage = `Oops! It seems there was an issue processing your payment. Please double-check your payment details and try again`;
              // FailedPopup(errorMessage);
            },
          },
        };

        const RazorpayCheckout = new window.Razorpay(options);
        RazorpayCheckout.on("payment.failed", function (response) {
          UpdatePaymentResponse(
            false,
            orderDetails.transaction_id,
            PaymentGateWay,
            orderDetails.pg_order_id,
            "",
            "",
            "",
            token,
            unregister_user
          );
          setPaymentSuccess(false);
          setOpenPaymentStatusModal(true);
          setPaymentStatusMsg(response.error.description);
          HandleAfterPayment();
        });
        RazorpayCheckout.open();
        handleEnableButton();
      }

      async function FEDBankPayment(gateway_details) {
        fedBankPG(gateway_details, callBack);
        function callBack(res) {
          console.log(res);
        }
      }

      async function CashFreePayment() {
        const cashfree = await load({ mode: orderDetails?.environment });
        let checkoutOptions = {
          paymentSessionId: orderDetails.payment_session_id,
          redirectTarget: "_modal",
        };
        cashfree
          .checkout(checkoutOptions)
          .then(async (result) => {
            if (result.error) {
              const data = getSessionStorage("paymentDetails");
              await UpdatePaymentResponse(
                true,
                data.transaction_id,
                data.PaymentGateWay,
                data.pg_order_id,
                data.payment_session_id,
                unregister_user
              );
            }
            if (result.redirect) {
              const data = getSessionStorage("paymentDetails");
              await UpdatePaymentResponse(
                true,
                data.transaction_id,
                data.PaymentGateWay,
                data.pg_order_id,
                data.payment_session_id,
                unregister_user
              );
            }
            if (result.paymentDetails) {
              const data = getSessionStorage("paymentDetails");
              await UpdatePaymentResponse(
                true,
                data.transaction_id,
                data.PaymentGateWay,
                data.pg_order_id,
                data.payment_session_id,
                unregister_user
              );
            }
          })
          .catch((error) => {
            console.log("cashfree catch error", error);
          });
      }

      async function EaseBuzzPayment() {
        setLoader(true);
        const res = await loadScript(orderDetails.gateway_details?.checkoutUrl);

        if (!res) {
          const errorMessage = "EaseBuzz SDK failed to load. Are you online?";
          FailedPopup(errorMessage);
          setLoader(false);
          return;
        }
        const options = {
          access_key: orderDetails.gateway_details?.accessKey,
          onResponse: (response) => {
            navigate(-1);
            customLogger(`Payment Success`, response);
            if (response?.txnid) {
              UpdatePaymentResponse(
                true,
                response?.txnid,
                PaymentGateWay,
                orderDetails.pg_order_id,
                "",
                "",
                response,
                token,
                unregister_user
              );
              setPaymentStatusMsg(Constant.paymentsussessMsg);
              setPaymentSuccess(true);
              setOpenPaymentStatusModal(true);
              HandleAfterPayment();
            }
          },
        };
        const easeBuzz = new window.EasebuzzCheckout(
          orderDetails.gateway_details?.key,
          orderDetails.gateway_details?.environment
        );
        easeBuzz.initiatePayment(options);
        handleEnableButton();
      }

      async function SBIPayment() {
        setLoader(true);

        try {
          let container = document.querySelector("#payment-gateways-list");
          const { order } = orderDetails.gateway_details;
          // console.log(order.transactionUrl);
          window.location.href = order.transactionUrl;
          {
            /*const htmlContent = `<form action="${order.transactionUrl}" method="post" name="server_request" target="_top" id = "form_id" >
              <input type="hidden" name="dummy" value="0" />
              <button type="submit" class="d-none" id="submit-btn"></button>
             </form>`;
          if (!container) {
            container = document.createElement("div");
            container.id = "container";
            document.body.appendChild(container);
          }
          container.innerHTML += htmlContent;
          document.querySelector("#submit-btn").click();*/
          }
        } catch (err) {
          console.log(err);
        }
      }
    }
  };

  const handleClosePaymentModal = () => {
    handleEnableButton();
    setPaymentModalVisible(false);
    if (redirect_url) {
      window.location.href = `${redirect_url}?error=You're back in the mobile app. If your payment isn't finished, please make sure to complete it. Need help? Just reach out to support.`;
    }
  };

  const UpdatePaymentResponse = useCallback(
    (
      status,
      transaction_id,
      gateway,
      order_id,
      payment_id,
      signature,
      payment_response,
      accessToken = token,
      unregister_user
    ) => {
      setLoader(true);
      let path = global.processpgresponse;
      let body = {};
      if (gateway === "AXIS_CF") {
        body = {
          transaction_id: transaction_id,
          gateway: gateway,
          payment_response: { orderId: transaction_id },
        };
      } else if (gateway === "UBI") {
        body = {
          transaction_id: transaction_id,
          gateway: gateway,
          payment_response: payment_response,
        };
      } else if (gateway === "AXIS" || gateway === "SIB") {
        body = {
          transaction_id: transaction_id,
          gateway: gateway,
          payment_response: {
            razorpay_order_id: order_id,
            razorpay_payment_id: payment_id,
            razorpay_signature: signature,
          },
        };
      } else {
        body = {
          transaction_id: transaction_id,
          gateway: gateway,
          payment_response: { razorpay_order_id: order_id },
        };
      }

      ManageApis("post", path, body, accessToken)
        .then((res) => {
          setLoader(false);
          customLogger("payment reponse updated success", res);
            const orderStatus = String(res?.response_data?.data?.order_status);
            customLogger(`Payment response order status : ${orderStatus}`);
            switch (orderStatus) {
              case "1":
                setPaymentStatusMsg(defaultTexts?.paymentInProcessMsg);
                setPaymentPending(true);
                setPaymentSuccess(false);
                setOpenPaymentStatusModal(true);
                HandleAfterPayment();
                break;
              case "2":
                setPaymentStatusMsg(Constant.paymentsussessMsg);
                setPaymentSuccess(true);
                setOpenPaymentStatusModal(true);
                HandleAfterPayment();
                break;
              case "3":
                setPaymentStatusMsg(defaultTexts?.paymentFailedMsg);
                setPaymentSuccess(false);
                setOpenPaymentStatusModal(true);
                HandleAfterPayment();
                break;
              default:
                console.log("unhandled conditon");
                FailedPopup("Something Went Wrong");
                break;
            }
        })
        .catch((err) => {
          setLoader(false);
        });
    },
    []
  );

  const getPaymentgateways = async () => {
    setLoader(true);
    try {
      const res = await ManageApis("get", global.gatewaylist, "", token);
      const { username } = getSessionStorage("userdetails") || {};
      setLoader(false);
      if (res.response_data.status) {
        if (res.response_data.data.gateways) {
          const activeGateways = res.response_data.data.gateways.filter(
            (gateway) => gateway.active == 1 && gateway.display == 1
          );
          // set the transaction charge info
          for (const gateway of activeGateways) {
            if (gateway.gatewayId === "SBI") {
              setShowPriceBanner(true);
              break;
            } else {
              setShowPriceBanner(false);
            }
          }
          setPaymentGateWays(activeGateways);
          setPaymentModalVisible(true);
        } else {
          setPaymentGateWays([]);
          setPaymentModalVisible(false);
          FailedPopup(
            "Due to maintenance activities payment is disabled, Please try after sometime"
          );
        }
      } else {
        FailedPopup(res.response_data.message);
      }
    } catch (err) {
      setLoader(false);
      FailedPopup(`something went Wrong`);
    }
  };

  const PaymentBackbtn = () => {
    setOpenPaymentStatusModal(false);
    if (window.location.pathname !== "/cart") {
      navigate("/cart");
    }
  };

  const UnregPaymentBackbtn = () => {
    setOpenPaymentStatusModal(false);
    if (paymentSuccess) {
      navigate("/login");
      localStorage.removeItem("quickToken");
      localStorage.removeItem("linkDetails");
    }
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("rzp_device_id");
    localStorage.removeItem("rzp_stored_checkout_id");
    localStorage.removeItem("paymentDetails");
  };

  return {
    paymentModalVisible,
    PaymentGateWays,
    loader,
    buttonDisable,
    OpenPaymentStatusModal,
    setOpenPaymentStatusModal,
    paymentPending,
    paymentSuccess,
    setPaymentSuccess,
    paymentStatusMsg,
    setPaymentStatusMsg,
    handleGateWay,
    handleClosePaymentModal,
    getPaymentgateways,
    PaymentBackbtn,
    UnregPaymentBackbtn,
    showPriceBanner
  };
};

export default usePaymentSection;
